var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnbookingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.715,
    height: 13.847,
    viewBox: "0 0 317.715 13.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3080",
    "data-name": "Group 3080",
    transform: "translate(-18733.234 -12548.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4409",
    "data-name": "Path 4409",
    d: "M78.15,7.1h-2.7v7.7c0,2.229-1.081,3.445-3.04,3.445S69.3,17.029,69.3,14.733V7.1H66.6v7.7c0,3.783,2.094,5.876,5.741,5.876s5.809-2.161,5.809-6.011Z",
    transform: "translate(18666.635 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    "data-name": "Path 4410",
    d: "M91.734,11.625l6.89,8.848h2.229V7.1H98.219v8.578L91.532,7.1H89.1V20.474h2.634Z",
    transform: "translate(18659.332 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 2.702,
    height: 13.374,
    transform: "translate(18764.17 12548.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    "data-name": "Path 4411",
    d: "M125.02,20.474h2.7V9.6h4.12V7.1H120.9V9.6h4.12Z",
    transform: "translate(18649.012 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    "data-name": "Path 4412",
    d: "M144.1,14.935h6.484V12.5H144.1V9.532h7.362V7.1H141.4V20.474h10.132V18.042H144.1Z",
    transform: "translate(18642.357 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    "data-name": "Path 4413",
    d: "M166.266,7.1H161.2V20.474h5.066c4.12,0,7.092-2.837,7.092-6.754C173.358,9.869,170.386,7.1,166.266,7.1ZM163.9,9.532h2.364a4.08,4.08,0,0,1,4.323,4.188v.068a4.043,4.043,0,0,1-4.323,4.188H163.9Z",
    transform: "translate(18635.932 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    "data-name": "Path 4414",
    d: "M194.934,11.625l6.89,8.848h2.161V7.1h-2.634v8.578L194.732,7.1H192.3V20.474h2.634Z",
    transform: "translate(18623.137 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4415",
    "data-name": "Path 4415",
    d: "M221.84,6.9h-2.364L213.6,20.341h2.769l1.351-3.107H223.6l1.351,3.107h2.837L221.976,6.968Zm.743,7.97h-3.85l1.891-4.526Z",
    transform: "translate(18616.225 12541.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4416",
    "data-name": "Path 4416",
    d: "M234.6,9.6h4.12V20.474h2.7V9.6h4.12V7.1H234.6Z",
    transform: "translate(18609.408 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 2.702,
    height: 13.374,
    transform: "translate(18857.99 12548.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4417",
    "data-name": "Path 4417",
    d: "M271.325,6.7a6.906,6.906,0,0,0-7.025,6.89v.068a6.766,6.766,0,0,0,6.957,6.89,6.92,6.92,0,0,0,7.025-6.957A6.766,6.766,0,0,0,271.325,6.7Zm0,2.5a4.193,4.193,0,0,1,4.188,4.458h0a4.194,4.194,0,1,1-8.376-.068A4.174,4.174,0,0,1,271.325,9.2Z",
    transform: "translate(18599.77 12541.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4418",
    "data-name": "Path 4418",
    d: "M298.951,15.678,292.332,7.1H289.9V20.474h2.634V11.625l6.89,8.848h2.161V7.1h-2.634Z",
    transform: "translate(18591.461 12541.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4419",
    "data-name": "Path 4419",
    d: "M317.747,12.474c-2.5-.608-2.9-1.013-2.9-1.891,0-.811.743-1.351,1.891-1.351a5.434,5.434,0,0,1,3.377,1.283l.135.135,1.418-2.026-.135-.135A7.357,7.357,0,0,0,316.666,6.8c-2.7,0-4.661,1.621-4.661,3.985,0,2.5,1.621,3.377,4.458,4.053,2.364.54,2.769,1.013,2.769,1.824,0,.878-.811,1.418-2.094,1.418a5.73,5.73,0,0,1-3.985-1.621l.068-.068L311.6,18.35l.135.135a7.984,7.984,0,0,0,5.539,2.094c2.9,0,4.863-1.621,4.863-4.12C322.069,14.365,320.854,13.217,317.747,12.474Z",
    transform: "translate(18584.418 12541.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3068",
    "data-name": "Group 3068",
    transform: "translate(18914.66 12548.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4420",
    "data-name": "Path 4420",
    d: "M75.067,40.814a3.291,3.291,0,0,0,1.754-3.09,3.032,3.032,0,0,0-.919-2.171A4.956,4.956,0,0,0,72.395,34.3H66.8V47.745h5.846c2.923,0,4.843-1.5,4.843-3.841C77.572,42.484,76.654,41.4,75.067,40.814ZM72.395,35.72c1.837,0,3.006.835,3.006,2.171,0,1.5-1.169,2.422-3.09,2.422H68.3V35.72Zm.334,10.689H68.3V41.732h4.175c1.42,0,3.674.334,3.674,2.338C76.069,45.49,74.817,46.409,72.729,46.409Z",
    transform: "translate(-66.801 -34.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4421",
    "data-name": "Path 4421",
    d: "M88.864,34.1A6.761,6.761,0,0,0,82.1,41.031h0a6.635,6.635,0,0,0,6.681,6.848,6.761,6.761,0,0,0,6.764-6.931A6.585,6.585,0,0,0,88.864,34.1Zm0,12.526A5.373,5.373,0,0,1,83.6,41.031a5.25,5.25,0,0,1,5.261-5.511,5.373,5.373,0,0,1,5.261,5.595h0A5.3,5.3,0,0,1,88.864,46.626Z",
    transform: "translate(-69.324 -34.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    "data-name": "Path 4422",
    d: "M107.664,34.1a6.761,6.761,0,0,0-6.764,6.931h0a6.635,6.635,0,0,0,6.681,6.848,6.761,6.761,0,0,0,6.764-6.931A6.585,6.585,0,0,0,107.664,34.1Zm0,12.526a5.373,5.373,0,0,1-5.261-5.595,5.25,5.25,0,0,1,5.261-5.511,5.373,5.373,0,0,1,5.261,5.595h0A5.4,5.4,0,0,1,107.664,46.626Z",
    transform: "translate(-72.425 -34.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4423",
    "data-name": "Path 4423",
    d: "M131.673,34.4h-2l-7.85,8.1V34.4H120.4V47.761h1.42V44.337l2.923-3.006L130,47.761h1.837l-6.1-7.432Z",
    transform: "translate(-75.64 -34.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 1.42,
    height: 13.445,
    transform: "translate(58.038 0.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4424",
    "data-name": "Path 4424",
    d: "M152.054,45.172l-8.6-10.772H142.2V47.761h1.42V36.738l8.768,11.023h1.086V34.4h-1.42Z",
    transform: "translate(-79.235 -34.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4425",
    "data-name": "Path 4425",
    d: "M165.38,41.866h4.342v3.34a6.4,6.4,0,0,1-3.841,1.336c-3.173,0-5.261-2.255-5.261-5.595a5.27,5.27,0,0,1,5.094-5.511,5.584,5.584,0,0,1,4.008,1.5l.167.167.919-1.086-.167-.167A6.948,6.948,0,0,0,165.8,34.1a6.674,6.674,0,0,0-6.6,6.931h0a6.466,6.466,0,0,0,6.764,6.848,8.085,8.085,0,0,0,5.261-2l.084-.084V40.447h-5.762v1.42Z",
    transform: "translate(-82.039 -34.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4426",
    "data-name": "Path 4426",
    d: "M192.886,40.329H185.12V34.4H183.7V47.761h1.42V41.749h7.766v6.013h1.42V34.4h-1.42Z",
    transform: "translate(-86.081 -34.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4427",
    "data-name": "Path 4427",
    d: "M209.887,42.15c0,2.839-1.42,4.426-4.092,4.426-2.589,0-4.175-1.67-4.175-4.593V34.3H200.2v7.766c0,3.591,2.088,5.846,5.512,5.846s5.511-2.255,5.511-5.929V34.3H209.8v7.85Z",
    transform: "translate(-88.802 -34.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4428",
    "data-name": "Path 4428",
    d: "M225.467,40.814a3.291,3.291,0,0,0,1.754-3.09,3.032,3.032,0,0,0-.919-2.171,4.956,4.956,0,0,0-3.507-1.253h-5.6V47.745h5.846c2.923,0,4.843-1.5,4.843-3.841C227.972,42.484,227.137,41.4,225.467,40.814Zm-2.672-5.094c1.837,0,3.006.835,3.006,2.171,0,1.5-1.169,2.422-3.09,2.422H218.7V35.72Zm.334,10.689H218.7V41.732h4.175c1.42,0,3.674.334,3.674,2.338C226.553,45.49,225.217,46.409,223.129,46.409Z",
    transform: "translate(-91.606 -34.132)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbookingLogo);
export default __webpack_public_path__ + "static/media/unbooking_logo.8283b6cf6cdfe06157d990970cca8681.svg";
export { ForwardRef as ReactComponent };